import { Wrapper, Icon, Text, TextInfo } from "./styled";

export const EmptyFavorite = ({ withInfo }) => {
  return (
    <Wrapper>
      <Icon
        src="/empty-favorite.svg"
        alt="Здесь пока что пусто"
        withInfo={withInfo}
      />
      <Text withInfo={withInfo}>Здесь пока пусто...</Text>
      {withInfo && (
        <TextInfo>
          Отметьте подкасты и музыку сердечком, чтобы они появились здесь.
        </TextInfo>
      )}
    </Wrapper>
  );
};
